import { render, staticRenderFns } from "./BpCustomPizza.vue?vue&type=template&id=6218922e&"
import script from "./BpCustomPizza.vue?vue&type=script&lang=js&"
export * from "./BpCustomPizza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports